import { render } from "./FooterSimple.vue?vue&type=template&id=6ef72929"
import script from "./FooterSimple.vue?vue&type=script&lang=js"
export * from "./FooterSimple.vue?vue&type=script&lang=js"

import "./FooterSimple.vue?vue&type=style&index=0&id=6ef72929&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__